<template>
    <div
        v-if="modalVisble"
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
    >
        <div
            class="
                flex
                items-end
                justify-center
                min-h-screen
                pt-4
                px-4
                pb-20
                text-center
                sm:block sm:p-0
            "
        >
            <div
                class="
                    fixed
                    inset-0
                    bg-gray-500 bg-opacity-75
                    transition-opacity
                "
                aria-hidden="true"
            ></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
            >

            <div
                class="
                    inline-block
                    align-bottom
                    bg-white
                    px-4
                    pt-5
                    pb-4
                    text-left
                    overflow-hidden
                    shadow-xl
                    transform
                    transition-all
                    sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6
                "
            >
                <div v-if="!asset.deleted_at">
                    <div>
                        <div class="mb-5">
                            <div class="text-xl font-bold text-center">
                                Are you sure you want to delete this asset?
                            </div>

                            <div class="mt-5">
                                <div class="text-gray-700 text-center">
                                    Deleted assets cannot be recovered.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 sm:mt-6 flex space-x-4">
                        <button
                            type="button"
                            class="
                                inline-flex
                                justify-center
                                w-full
                                bg-gray-500
                                hover:bg-gray-700
                                text-white
                                font-bold
                                py-2
                                px-4
                                rounded
                            "
                            @click="deleteAsset()"
                        >
                            Delete Asset
                        </button>

                        <button
                            type="button"
                            class="
                                inline-flex
                                justify-center
                                w-full
                                bg-blue-500
                                hover:bg-blue-700
                                text-white
                                font-bold
                                py-2
                                px-4
                                rounded
                            "
                            @click="closeModal()"
                        >
                            Back to editing
                        </button>
                    </div>
                </div>

                <div v-if="asset.deleted_at">
                    <div>
                        <div class="mb-5">
                            <div class="text-xl font-bold text-center">
                                Are you sure you want to restore this asset?
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 sm:mt-6 flex space-x-4">
                        <button
                            type="button"
                            class="
                                inline-flex
                                justify-center
                                w-full
                                bg-gray-500
                                hover:bg-gray-700
                                text-white
                                font-bold
                                py-2
                                px-4
                                rounded
                            "
                            @click="restoreAsset()"
                        >
                            Restore Asset
                        </button>

                        <button
                            type="button"
                            class="
                                inline-flex
                                justify-center
                                w-full
                                bg-blue-500
                                hover:bg-blue-700
                                text-white
                                font-bold
                                py-2
                                px-4
                                rounded
                            "
                            @click="closeModal()"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button v-if="!asset.deleted_at" class="underline" @click="showModal()">
        Delete asset
    </button>
    <button v-if="asset.deleted_at" class="underline" @click="showModal()">
        Restore asset
    </button>
</template>

<script>
export default {
    props: ["asset"],
    emits: [],
    components: {},
    data() {
        return {
            modalVisble: false,
            currentPageType: "",
        };
    },
    methods: {
        showModal() {
            this.modalVisble = true;
        },
        closeModal() {
            this.modalVisble = false;
        },
        deleteAsset() {
            axios
                .delete(`/api/brand-guideline-assets/` + this.asset.id, {
                    data: {
                        type: this.currentPageType
                    }
                })
                .then((response) => {
                    window.location.href ="/guidelines";
                })
                .catch((error) => {
                    if (error.response) {
                        // console.log(error.response.data.errors);
                    } else if (error.request) {
                        // console.log(error.request);
                    } else {
                        // console.log("Error", error.message);
                    }
                });
        },
    },
    mounted() {
        this.currentPageType = window.location.pathname.split("/")[1];
    },
};
</script>

<style scoped>
</style>
